// Parser para o arquivo "extrato_vendas_erp.csv"

export const detectar = (dadosArray) => {
    // Procura nas primeiras linhas os cabeçalhos característicos
    for (let i = 0; i < Math.min(20, dadosArray.length); i++) {
        const row = dadosArray[i];
        if (!row || !Array.isArray(row)) continue;
        
        // Remove espaços, caracteres especiais ocultos (BOM) e passa para minúsculo
        const rowStr = row.map(c => String(c).toLowerCase().trim().replace(/^\ufeff/, ''));
        
        if (
            rowStr.includes('forma_pagamento') && 
            rowStr.includes('conta_caixa') && 
            rowStr.includes('data_venda') && 
            rowStr.includes('valor')
        ) {
            return true;
        }
    }
    return false;
};

export const processar = (dadosArray) => {
    let headerIndex = -1;
    let headers = [];

    // Localizar cabeçalhos
    for (let i = 0; i < Math.min(20, dadosArray.length); i++) {
        const row = dadosArray[i];
        if (!row || !Array.isArray(row)) continue;
        
        const rowStr = row.map(c => String(c).toLowerCase().trim().replace(/^\ufeff/, ''));
        if (rowStr.includes('forma_pagamento') && rowStr.includes('data_venda')) {
            headerIndex = i;
            headers = rowStr;
            break;
        }
    }

    if (headerIndex === -1) {
        throw new Error('Cabeçalhos não encontrados no arquivo do Extrato ERP.');
    }

    const dateIdx = headers.indexOf('data_venda');
    const valIdx = headers.indexOf('valor');
    const statusIdx = headers.indexOf('status');
    const metPagtoIdx = headers.indexOf('forma_pagamento');

    const vendas = [];

    for (let i = headerIndex + 1; i < dadosArray.length; i++) {
        const row = dadosArray[i];
        if (!row || row.length === 0) continue;

        const rawData = row[dateIdx];
        const rawValor = row[valIdx];
        const rawStatus = row[statusIdx] !== undefined ? String(row[statusIdx]).trim().toLowerCase() : '';
        const rawPagto = row[metPagtoIdx] !== undefined ? String(row[metPagtoIdx]).trim() : '';

        // Ignorar linhas vazias
        if (!rawData && !rawValor) continue;

        // Regra 1: Descartar "Aberto" (aceitar "Baixado" ou vazios se não tiver controle rígido)
        if (rawStatus === 'aberto') {
            continue;
        }

        // Converter Valor (ex: "49,68" -> 49.68)
        let valorNum = 0;
        if (typeof rawValor === 'number') {
            valorNum = rawValor;
        } else if (typeof rawValor === 'string') {
            valorNum = parseFloat(rawValor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim());
        }

        // Regra 2: Ignorar valor inválido ou zero
        if (isNaN(valorNum) || valorNum <= 0) {
            continue;
        }

        // Formatar Data (DD/MM/YYYY -> YYYY-MM-DD)
        let dataFormatada = rawData;
        if (typeof rawData === 'string') {
            const dateStr = rawData.trim().split(' ')[0]; // Em caso de vir com hora na mesma coluna
            const match = dateStr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (match) {
                dataFormatada = `${match[3]}-${match[2]}-${match[1]}`;
            } else if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
                dataFormatada = dateStr;
            }
        }
        const pagtoUpper = String(rawPagto || '').toUpperCase();
        let categoria = 'cartao';
        if (pagtoUpper.includes('PIX')) {
            categoria = 'pix';
        } else if (pagtoUpper.includes('ALIMENTAÇÃO') || pagtoUpper.includes('ALIMENTACAO') || pagtoUpper.includes('REFEIÇÃO') || pagtoUpper.includes('REFEICAO') || pagtoUpper.includes('VOUCHER')) {
            categoria = 'voucher';
        }

        vendas.push({
            linha: i + 1,
            data: dataFormatada,
            valor: valorNum,
            formaPagamento: rawPagto,
            bandeira: rawPagto,
            categoria: categoria,
            status: rawStatus ? (rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1)) : 'Baixado',
            tipo: ''
        });
    }

    return vendas;
};
